export default function Loading() {
  return <div className="loading">로딩</div>;
}
